"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("./../../../_util/useConfig"));
/**
 * 传入卡片内容
 * @param props
 * @constructor
 */
var CardList = function (props) {
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var img = props.img, title = props.title, contentDescribe = props.contentDescribe;
    return (react_1.default.createElement("div", { className: "".concat(classPrefix, "-items-card") },
        react_1.default.createElement("div", { className: "".concat(classPrefix, "-object") },
            react_1.default.createElement("img", { src: img, alt: "" })),
        react_1.default.createElement("div", { className: "".concat(classPrefix, "-main") },
            react_1.default.createElement("span", null, title),
            react_1.default.createElement("p", null, contentDescribe))));
};
exports.default = CardList;
//# sourceMappingURL=CardList.js.map